__turbopack_context__.v({
  "dropdown": "select-module__Had0aa__dropdown",
  "input": "select-module__Had0aa__input",
  "option": "select-module__Had0aa__option",
});
